import { render } from "./CustomUploadImage.vue?vue&type=template&id=45d79490&ts=true"
import script from "./CustomUploadImage.vue?vue&type=script&lang=ts"
export * from "./CustomUploadImage.vue?vue&type=script&lang=ts"

import "./CustomUploadImage.vue?vue&type=style&index=0&id=45d79490&lang=scss"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__